import React from 'react'
import {Header,Footer, ServicesWeOffer} from '../components/components'

const Services = () => {
  return (
   <>
   <Header/>
   <ServicesWeOffer/>
   <Footer/>
   </>
  )
}

export default Services